import { render, staticRenderFns } from "./AssignRoleToUser.vue?vue&type=template&id=589b8d7f&"
import script from "./AssignRoleToUser.vue?vue&type=script&lang=js&"
export * from "./AssignRoleToUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports